module.exports = "<input class=form-control type=number ng-change=$ctrl.updateTime() ng-model=$ctrl.hours min=0 max=100 placeholder=\"{{ 'hh' | translate }}\" title=\"{{ 'hh' | translate }}\"> : <input class=form-control type=number ng-change=$ctrl.updateTime() ng-model=$ctrl.minutes app-widgets-novalidation=step step=15 min=0 max=59 placeholder=\"{{ 'mm' | translate }}\" title=\"{{ 'mm' | translate }}\"> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/widgets/time/partial.html
// module id = 564
// module chunks = 0